import { makeStyles, Theme } from '@material-ui/core/styles'
import clsx from 'clsx'
import GridContainer from 'components/Surfaces/GridContainer'
import GridItem from 'components/Surfaces/GridItem'
import React, { useEffect } from 'react'
import { ListingStatus } from '../../ListingStatusVariant'
import { optionItems } from '../MoreFilterCategoryCheckbox'
import CategoryCheckbox from './CategoryCheckbox'

const useStyles = makeStyles((theme: Theme) => ({
    subProperty: {
        lineHeight: '3px',
        padding: '8px 24px',
        textTransform: 'capitalize',
    },
    gridValues: {
        ...theme.typography.body1,
        padding: '0px',
    },
    gridContainer: {
        flexGrow: 1,
        maxWidth: '30vw',
        flexBasis: 0,
    },
    gridContainerWithoutFlexGrow: {
        maxWidth: '100%',
        flexBasis: 0,
    },
    endElem: {
        flexDirection: 'column',
    },
}))

export interface StatusCategoryCheckboxProps {
    optionList: optionItems[]
    selectedValues: string[]
    disabledValues?: string[] | undefined
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}
const StatusCategoryCheckbox: React.FC<StatusCategoryCheckboxProps> = ({
    optionList,
    selectedValues,
    handleChange,
    disabledValues,
}) => {
    const [formattedArray, setFormattedArray] = React.useState<optionItems[][]>(
        []
    )

    const classes = useStyles()

    useEffect(() => {
        let tempArray: optionItems[][] = []
        let optionListCopy = [...optionList]
        while (optionListCopy.length !== 0) {
            tempArray.push(optionListCopy.splice(0, 2))
        }
        setFormattedArray(tempArray)
    }, [optionList])

    return (
        <GridContainer>
            {formattedArray.map((row, index) => {
                return (
                    <GridContainer
                        key={index}
                        className={clsx(
                            classes.subProperty,
                            classes.gridContainer,
                            row?.[0]?.name === ListingStatus.Completed &&
                                classes.endElem
                        )}
                        data-testid="rowGrid"
                    >
                        {row.map((item, index) => {
                            return (
                                <GridItem
                                    className={clsx(classes.gridValues)}
                                    key={item.value}
                                    data-testid="checkboxes"
                                >
                                    <CategoryCheckbox
                                        item={item}
                                        itemKey={`${item.name}${index}`}
                                        isSelected={
                                            !!selectedValues?.includes(
                                                item.value
                                            )
                                        }
                                        isDisabled={disabledValues?.includes(
                                            item.value
                                        )}
                                        handleChange={handleChange}
                                    />
                                </GridItem>
                            )
                        })}
                    </GridContainer>
                )
            })}
        </GridContainer>
    )
}

export default StatusCategoryCheckbox
